module.exports = __webpack_public_path__ + "img/kitchen_02.44051ddf.png";